import api from "./Interceptor";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const getAllSlots = async () => {
  try {
    const response = await api.get(`${BASE_URL}/slot-manage`);
    return response.data;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error?.response?.data || new Error("Failed to fetch blogs");
  }
};

export const addOrUpdateSlot = async (day, payload) => {
  try {
    const response = await api.put(`${BASE_URL}/slot-manage/${day}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating slots:", error);
    throw error?.response?.data || new Error("Failed to update slots");
  }
};
